import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Layout from "../layout/Layout";
import { CSVLink } from "react-csv";
import { api } from "../utils/Api";
import { Button, Flex, notification, Typography } from "antd";
import dayjs from "dayjs";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
const { Text } = Typography;

const columns = [
	{
		title: "Customer",
		dataIndex: "customer",
		key: "customer",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Job No.",
		dataIndex: "number",
		key: "number",
		render: (value) => {
			return <Text>{value}</Text>;
		},
		width: 100,
	},
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
		width: 100,
	},
	{
		title: "Time",
		dataIndex: "time",
		key: "time",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Address",
		dataIndex: "shipAddress",
		key: "shipAddress",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Job Type",
		dataIndex: "jobType",
		key: "jobType",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Load",
		dataIndex: "loadYD3",
		key: "loadYD3",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Target",
		dataIndex: "targetYD3",
		key: "targetYD3",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "jobStatus",
		key: "jobStatus",
		render: (value) => {
			return <Text>{value}</Text>;
		},
		width: 100,
	},
	{
		title: "Pour",
		dataIndex: "jobPoor",
		key: "jobPoor",
		render: (value) => {
			return <Text>{value}</Text>;
		},
		width: 150,
	},
	{
		title: "Slump",
		dataIndex: "slump",
		key: "slump",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Destination Time",
		dataIndex: "destinationMinutes",
		key: "destinationMinutes",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "PSI",
		dataIndex: "psi",
		key: "psi",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Seller",
		dataIndex: "seller",
		key: "seller",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Balance",
		dataIndex: "balance",
		key: "balance",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Plant",
		dataIndex: "plant",
		key: "plant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
		width: 150,
	},
	{
		title: "Subplant",
		dataIndex: "subplant",
		key: "subplant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const ScheduledSalesReport = () => {
	const [rows, setRows] = useState([]);
	const [date, setDate] = useState(dayjs());
	const [loading, setLoading] = useState(true);
	const [plant, setPlant] = useState("All");
	const [plants, setPlants] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const refDownload = useRef();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlants();
	}, []);

	useEffect(() => {
		getJobs();
	}, [date, plant]);

	const getPlants = async () => {
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/plant/list/options`;

		try {
			const { data } = await axios.get(url);
			let list = [{ value: "All", label: "All" }];

			if (data.success) {
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setPlants(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", "Cannot get plants");
			return null;
		}
	};

	const refactorJobStatus = (jobStatus) => {
		let status = jobStatus;
		if (status === "ok") {
			status = "Poured";
		} else if (status === "Confirm") {
			status = "A/R Confirmed";
		} else if (status === "Active") {
			status = "Pouring";
		} else if (status === "Ready to Load") {
			status = "Ready to be scheduled";
		}
		return status;
	};
	const sanitize = (val) =>
		typeof val === "string" ? val.replace(/"/g, "'") : val || "NA";

	const getJobs = async () => {
		setLoading(true);
		const start = `${date.year()}-${date.month() + 1}-${date.date()}`;
		const url =
			api + `/job/scheduled/byplant/57Concrete?date=${start}&plant=${plant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				const newRows = data.payload.map((dato) => {
					let customer = "NA";
					if (dato.customer !== null) {
						customer = dato.customer.customerNumber + " " + dato.customer.name;
					}

					let seller = "NA";
					if (dato.seller !== null) {
						seller = dato.seller.name;
					}

					return {
						comments: dato.comments,
						destinationMinutes: dato.destinationMinutes,
						balance: dato.balance,
						customer,
						seller,
						jobType: dato.jobType,
						jobStatus: refactorJobStatus(dato.jobStatus),
						jobPoor: dato.jobPoor,
						psi: sanitize(dato.psiId ? dato.psiId.psi : dato.psi),
						number: dato.number,
						date: `${new Date(dato.scheduledDate).toLocaleDateString()}`,
						time: `${new Date(dato.scheduledDate).toLocaleTimeString([], {
							timeStyle: "short",
						})}`,
						shipAddress: dato.shipAddress,
						loadYD3: dato.loadYD3,
						targetYD3: dato.targetYD3,
						slump: dato.slump,
						plant: dato.plant ? dato.plant.name : "NA",
						subplant: dato.subplant ? dato.subplant : "NA",
					};
				});
				setRows(newRows);
				setLoading(false);
			} else {
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	const onChangeDate = (currentDate) => {
		setDate(currentDate);
	};

	const onChangePlant = (selectedPlant) => {
		setPlant(selectedPlant);
	};

	const RenderDatesAndFilters = () => {
		return (
			<CustomSearch
				loading={loading}
				startDate={date}
				onDateChange={onChangeDate}
				dateFormat={"MM/DD/YYYY"}
				labelPicker={"Select plant"}
				pickerWidth={"200px"}
				optionsPicker={plants}
				onChangePicker={onChangePlant}
				pickerValue={plant}
				allowClearPicker={false}
				allowClearDate={false}
			/>
		);
	};

	return (
		<Layout title="Scheduled Sales Report" description="Jobs Report">
			{contextHolder}
			<Flex gap={8}>
				<RenderDatesAndFilters />
			</Flex>
			{loading ? (
				<CustomSpinner />
			) : (
				<Flex gap={6} vertical>
					<CustomTable columns={columns} data={rows} isScroll={false} />
					<CSVLink
						data={rows}
						headers={headers()}
						filename={"57concrete-scheduled-report.csv"}
						hidden
						ref={refDownload}
					>
						Download report
					</CSVLink>
					<Button
						size="large"
						type="primary"
						style={{ width: "170px" }}
						onClick={(e) => refDownload.current.link.click()}
						loading={loading}
					>
						Download Report
					</Button>
				</Flex>
			)}
		</Layout>
	);
};

export default ScheduledSalesReport;
